import React from "react";
import Box from "@material-ui/core/Box";
import { SportCodes } from "@prestosports/prestostats-core/Common";
import individualStatsStyles from "../styles/IndividualStats.styles";
import IndividualStatsTable from "./IndividualStatsTable";
import { useGameContext } from "../../../state/game/context";

const IndividualTeamStats = ({ playerStats }) => {
	const classes = individualStatsStyles();

	const { state: gameContextState } = useGameContext();
	const game = gameContextState.game();

	return (
		<Box className={classes.individualTeamStats}>
			<IndividualStatsTable
				title="Passing"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Comp",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Att",
						func: (data) => data.attempted,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Yds",
						func: (data) => data.totalYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Lg",
						func: (data) => data.longestYard,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Td",
						func: (data) => data.touchdowns,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Int",
						func: (data) => data.interceptions,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Sck",
						func: (data) => data.sack,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="passing"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Rushing"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Att",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Gain",
						func: (data) => data.gainedYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Loss",
						func: (data) => data.lostYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Net Yds",
						func: (data) => data.totalYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Lg",
						func: (data) => data.longestYard,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Avg",
						func: (data) => data.averageYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Td",
						func: (data) => data.touchdowns,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="rushing"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Receiving"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Rec",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Yds",
						func: (data) => data.totalYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Tar",
						func: (data) => data.attempted,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Avg",
						func: (data) => data.averageYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Lg",
						func: (data) => data.longestYard,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Td",
						func: (data) => data.touchdowns,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="receiving"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Defense"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Tkl",
						func: (data) => data.tackles,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Sck",
						func: (data) => data.sacks,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Tfl",
						func: (data) => data.tfl,
						align: "right",
						alignHeader: "right"
					},
					// {
					// 	name: "Tfl Yds",
					// 	func: (data) => data.tflYards,
					// 	align: "right",
					// 	alignHeader: "right"
					// },
					{
						name: "Int",
						func: (data) => data.interceptions,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Int Yds",
						func: (data) => data.interceptionYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Int Td",
						func: (data) => data.tdfi,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Ff",
						func: (data) => data.ff,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Fr",
						func: (data) => data.fr,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Fr Yds",
						func: (data) => data.fumbleReturnedYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Fr Td",
						func: (data) => data.fumbleReturnedTouchdowns,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Blks",
						func: (data) => data.blocks,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "BrUps",
						func: (data) => data.passBrokenUp,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="defense"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Punts"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Tot",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Yds",
						func: (data) => data.totalYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Avg",
						func: (data) => data.averageYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Lg",
						func: (data) => data.longestYard,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "In20",
						func: (data) => data.in20,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Tb",
						func: (data) => data.touchback,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Rouge",
						func: (data) => data.rouge,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="punting"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Punt Returns"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Tot",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Yds",
						func: (data) => data.totalYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Avg",
						func: (data) => data.averageYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Lg",
						func: (data) => data.longestYard,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Td",
						func: (data) => data.touchdowns,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="puntReturn"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Penalities"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Tot",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Yds",
						func: (data) => data.absoluteYards,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="penalty"
				rows={playerStats}
			/>
			<IndividualStatsTable
				title="Miscellaneous"
				columns={[
					{
						name: "#",
						func: (data) => data.uniform,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "",
						func: (data) => data.fullName,
						align: "left",
						alignHeader: "left"
					},
					{
						name: "Att",
						func: (data) => data.completed,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Yds",
						func: (data) => data.totalYards,
						align: "right",
						alignHeader: "right"
					},
					{
						name: "Avg",
						func: (data) => data.averageYards,
						align: "right",
						alignHeader: "right"
					}
				]}
				statFilterField="misc"
				rows={playerStats}
			/>
			{game?.sportCode === SportCodes.Football && (
				<>
					<IndividualStatsTable
						title="Kickoffs"
						columns={[
							{
								name: "#",
								func: (data) => data.uniform,
								align: "left",
								alignHeader: "left"
							},
							{
								name: "",
								func: (data) => data.fullName,
								align: "left",
								alignHeader: "left"
							},
							{
								name: "Tot",
								func: (data) => data.completed,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Yds",
								func: (data) => data.totalYards,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Avg",
								func: (data) => data.averageYards,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Tb",
								func: (data) => data.touchback,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Rouge",
								func: (data) => data.rouge,
								align: "right",
								alignHeader: "right"
							}
						]}
						statFilterField="kickoff"
						rows={playerStats}
					/>
					<IndividualStatsTable
						title="Kickoff Returns"
						columns={[
							{
								name: "#",
								func: (data) => data.uniform,
								align: "left",
								alignHeader: "left"
							},
							{
								name: "",
								func: (data) => data.fullName,
								align: "left",
								alignHeader: "left"
							},
							{
								name: "Tot",
								func: (data) => data.completed,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Yds",
								func: (data) => data.totalYards,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Avg",
								func: (data) => data.averageYards,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Lg",
								func: (data) => data.longestYard,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "td",
								func: (data) => data.touchdowns,
								align: "right",
								alignHeader: "right"
							}
						]}
						statFilterField="kickoffReturn"
						rows={playerStats}
					/>

					<IndividualStatsTable
						title="Kicking"
						columns={[
							{
								name: "#",
								func: (data) => data.uniform,
								align: "left",
								alignHeader: "left"
							},
							{
								name: "",
								func: (data) => data.fullName,
								align: "left",
								alignHeader: "left"
							},
							{
								name: "FG Good / Att",
								func: (data) => `${data.completed} / ${data.attempted}`,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Lg",
								func: (data) => data.longestYard,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "XP Good / Att",
								func: (data) => `${data.patCompleted} / ${data.patAttempted}`,
								align: "right",
								alignHeader: "right"
							},
							{
								name: "Rouge",
								func: (data) => data.rouge,
								align: "right",
								alignHeader: "right"
							}
						]}
						statFilterField="fieldGoal"
						rows={playerStats}
					/>
				</>
			)}
		</Box>
	);
};

export default IndividualTeamStats;
